import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IabandonedApps } from '../sidenav/helper';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { HomeService } from '../services/homeservice';
import { DynamicTabsService } from '../dynamic-tabs.service';
import { MatSort } from '@angular/material/sort';
@Component({
  selector: 'app-guides',
  templateUrl: './guides.component.html',
  styleUrls: ['./guides.component.css']
})
export class GuidesComponent {
  @Input() label: string = '';
  @Input() type: string = '';
  @Output() emitAssnId = new EventEmitter();
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort,{static:true})sort!:MatSort;
  abandoned!: IabandonedApps[];
  searchTerm: string = '';
  filteredData: IabandonedApps[] = [];
  sortingColumn: string = '';
  sortOrder: 'asc' | 'desc' = 'asc';
  isSearching: boolean = false;
  isLoading: boolean=false;
  dataSource!: MatTableDataSource<IabandonedApps>;
  totalItems: number = 0;
  currentPageIndex: number = 0;
  pageSize: number = 45;
  pageSizeOptions: number[] = [45, 90, 135];
  isHidePageSize: boolean = true;
  showFirstLastButtons = true;
  currentPage: number = 0;
  columnsToDisplay: string[] = [
    'startedDate',
    'applicantName',
    'contactName',
    'requestedEffectiveDate',
    'referralSourceId',
    'referralSourceDetails',
    'emailAddress',
    'mainNumber',
    'mobileNumber',
    'faxNumber',
    'website',
    'address1',
    'address2',
    'city',
    'stateId',
    'postalCode',
    'descriptionOfOperations',
    'yearsInOperation',
    'priorExperience'
  ]

  constructor(private service: HomeService, public dynamicTabService: DynamicTabsService) {
    this.dataSource = new MatTableDataSource<IabandonedApps>([]);
  }
  ngOnInit() {
    this.getAbandonedData();
    //refresh
    this.dynamicTabService.refreshObv.subscribe(value => {
      if (value && this.dynamicTabService.selectedTab == 'Abandoned Apps')
        this.refresh();
    })  
    this.loadTableData();
  }

  ngAfterViewInit()
  {
    this.paginator.pageSize=45;
    this.checkRowsPerPage();
  }
  //event listener for searching
  @HostListener('document:keyup.enter',['$event'])
  handleEnterKey(event:KeyboardEvent)
  {
    if(event.key==='Enter')
    {
      this.search();
    }
  }
  //checking number of rows per page
  checkRowsPerPage() {
    if (this.paginator) {
      const rowsPerPage = this.paginator.pageSize;
      // console.log(`Number of rows per page:${rowsPerPage}`);
    }
  }

  loadTableData()
  {
    this.isLoading=true;
    this.getAbandonedData();
  }

  getAbandonedData(): void {
    this.service.getAbandonedApps().subscribe((res: IabandonedApps[]) => {
      this.abandoned = res;
      this.filteredData = this.abandoned;
      this.totalItems = this.filteredData.length;
      this.applyPagination();
      this.isLoading = false;
      res.sort((a,b)=>
      {
        const valueA = a.startedDate;
        const valueB = b.startedDate;
        // console.log("StartedDate sorted ascending while loading abandoned apps");
        return (valueA)-(valueB);
    
      });
      this.dataSource.data=res;
      this.dataSource.sort=this.sort;

    })
  }
  refresh() {
    if(this.dynamicTabService.selectedTabData.id==-11){
    this.getAbandonedData();
    this.isLoading = true;
    this.clearSearch();
    // console.log("Abandoned Apps refreshed");
  }
  }

  onPageChange(event: any): void {
    this.currentPageIndex = event.pageIndex;
    this.pageSize = 45;
    this.applyPagination();
  }

  applyPagination(): void {
    const startIndex = this.currentPageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.dataSource.data = this.filteredData.slice(startIndex, endIndex);
  }


 

  pageChanged(page: number): void {
    this.currentPage = page;
    this.filterData();
  }
  filterData(): void {
    const startIndex = this.currentPageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.filteredData = this.dataSource.data.slice(startIndex, endIndex);
  }
  applyFilter(): void {
    this.pageSize=45;
    this.currentPageIndex = 0;
    const searchValue = this.searchTerm.trim().toLowerCase();
    this.filteredData = this.abandoned.filter((item) => {
      const searchFields = [item.applicantName,
      item.contactName,
      item.city,
      item.address1,
      item.address2,
      item.emailAddress,
      item.postalCode,
      item.stateId,
      item.descriptionOfOperations,
      item.yearsInOperation];
      return searchFields.some((field) => String(field).toLowerCase().includes(searchValue));
    });
    this.totalItems = this.filteredData.length;
    this.isSearching = searchValue != '';
    this.applyPagination();
  }
  search(): void {
    this.applyFilter();
  }
  clearSearch(): void {
    this.pageSize=45;
    this.currentPageIndex = 0;
    this.searchTerm = '';
    this.isSearching = false;
    this.filteredData = this.abandoned;
    this.totalItems = this.abandoned.length;

    this.applyPagination();
  }
  getTotalPages(): number {
    return Math.ceil(this.abandoned.length / this.pageSize);
  }

  sortData(column: keyof IabandonedApps) {
    if (this.sortingColumn === column) {

      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    }
    else {
      this.sortingColumn = column;
      this.sortOrder = 'asc';
    }
    this.abandoned.sort((a, b) => {
        const valueA =( a[column] || '').toString();
        const valueB = (b[column] || '').toString();
  //compare mixed-case values
        if (valueA.toLowerCase() < valueB.toLowerCase()) {
          return this.sortOrder === 'asc' ? -1 : 1;
        }
  
        else if (valueA.toLowerCase() > valueB.toLowerCase()) {
          return this.sortOrder === 'asc' ? 1 : -1;
        }
  
       //Handle empty values
       if(valueA === '' && valueB ===''){
        return 0;
       }else if(valueA === ''){
        return -1;
       }else if(valueB === ''){
        return 1;
       }
       return 0;
  
      });
    this.applyPagination();
  }
}

